/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CtmsCategoryCreateReqVo,
  CtmsCategoryUpdateReqVo,
  CtmsItemCreateReqVo,
  CtmsItemUpdateReqVo,
  ResponseCtmsCategoryRespVo,
  ResponseCtmsItemRespVo,
  ResponseListCtmsItemOptionRespVo,
  ResponseListGetCtmsCategoryOptionRespVo,
  ResponseLong,
  ResponsePageDataCtmsCategoryRespVo,
  ResponsePageDataCtmsItemRespVo,
} from '../models/index';
import {
    CtmsCategoryCreateReqVoFromJSON,
    CtmsCategoryCreateReqVoToJSON,
    CtmsCategoryUpdateReqVoFromJSON,
    CtmsCategoryUpdateReqVoToJSON,
    CtmsItemCreateReqVoFromJSON,
    CtmsItemCreateReqVoToJSON,
    CtmsItemUpdateReqVoFromJSON,
    CtmsItemUpdateReqVoToJSON,
    ResponseCtmsCategoryRespVoFromJSON,
    ResponseCtmsCategoryRespVoToJSON,
    ResponseCtmsItemRespVoFromJSON,
    ResponseCtmsItemRespVoToJSON,
    ResponseListCtmsItemOptionRespVoFromJSON,
    ResponseListCtmsItemOptionRespVoToJSON,
    ResponseListGetCtmsCategoryOptionRespVoFromJSON,
    ResponseListGetCtmsCategoryOptionRespVoToJSON,
    ResponseLongFromJSON,
    ResponseLongToJSON,
    ResponsePageDataCtmsCategoryRespVoFromJSON,
    ResponsePageDataCtmsCategoryRespVoToJSON,
    ResponsePageDataCtmsItemRespVoFromJSON,
    ResponsePageDataCtmsItemRespVoToJSON,
} from '../models/index';

export interface CtmsCategoryIdDeleteRequest {
    id: number;
}

export interface CtmsCategoryIdGetRequest {
    id: number;
}

export interface CtmsCategoryIdPutRequest {
    id: number;
    ctmsCategoryUpdateReqVo?: CtmsCategoryUpdateReqVo;
}

export interface CtmsCategoryPageListGetRequest {
    currentPage: number;
    pageSize: number;
}

export interface CtmsCategoryPostRequest {
    ctmsCategoryCreateReqVo?: CtmsCategoryCreateReqVo;
}

export interface CtmsItemBatchDownloadGetRequest {
    currentPage: number;
    pageSize: number;
    ctmsCategoryId?: number;
    hsCode?: string;
    itemName?: string;
    itemNameEn?: string;
    itemNameCn?: string;
    list?: number;
    kcCertification?: number;
    orderBy?: string;
    orderType?: string;
}

export interface CtmsItemBatchUploadPostRequest {
    file: Blob;
}

export interface CtmsItemIdDeleteRequest {
    id: number;
}

export interface CtmsItemIdGetRequest {
    id: number;
}

export interface CtmsItemIdPutRequest {
    id: number;
    ctmsItemUpdateReqVo?: CtmsItemUpdateReqVo;
}

export interface CtmsItemPageListGetRequest {
    currentPage: number;
    pageSize: number;
    ctmsCategoryId?: number;
    hsCode?: string;
    itemName?: string;
    itemNameEn?: string;
    itemNameCn?: string;
    list?: number;
    kcCertification?: number;
    orderBy?: string;
    orderType?: string;
}

export interface CtmsItemPostRequest {
    ctmsItemCreateReqVo?: CtmsItemCreateReqVo;
}

/**
 * 
 */
export class CtmsControllerApi extends runtime.BaseAPI {

    /**
     * 指定分类编号,删除通关类目分类 已经显限制: 1. 删除的分类下没有项目 删除通关类目分类信息
     * 删除通关类目分类信息
     */
    async ctmsCategoryIdDeleteRaw(requestParameters: CtmsCategoryIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ctmsCategoryIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ctms/category/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 指定分类编号,删除通关类目分类 已经显限制: 1. 删除的分类下没有项目 删除通关类目分类信息
     * 删除通关类目分类信息
     */
    async ctmsCategoryIdDelete(requestParameters: CtmsCategoryIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.ctmsCategoryIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定百编号,获取类目分类信息详情 获取类目分类信息详情
     * 获取类目分类信息详情
     */
    async ctmsCategoryIdGetRaw(requestParameters: CtmsCategoryIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCtmsCategoryRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ctmsCategoryIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ctms/category/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCtmsCategoryRespVoFromJSON(jsonValue));
    }

    /**
     * 指定百编号,获取类目分类信息详情 获取类目分类信息详情
     * 获取类目分类信息详情
     */
    async ctmsCategoryIdGet(requestParameters: CtmsCategoryIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCtmsCategoryRespVo> {
        const response = await this.ctmsCategoryIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 修改通关类目分类 修改通关类目分类信息
     * 修改通关类目分类信息
     */
    async ctmsCategoryIdPutRaw(requestParameters: CtmsCategoryIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ctmsCategoryIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ctms/category/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CtmsCategoryUpdateReqVoToJSON(requestParameters['ctmsCategoryUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 修改通关类目分类 修改通关类目分类信息
     * 修改通关类目分类信息
     */
    async ctmsCategoryIdPut(requestParameters: CtmsCategoryIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.ctmsCategoryIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 通关类目分类options 获取通关类目分类options
     * 获取通关类目分类options
     */
    async ctmsCategoryOptionsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListGetCtmsCategoryOptionRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ctms/category/options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListGetCtmsCategoryOptionRespVoFromJSON(jsonValue));
    }

    /**
     * 通关类目分类options 获取通关类目分类options
     * 获取通关类目分类options
     */
    async ctmsCategoryOptionsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListGetCtmsCategoryOptionRespVo> {
        const response = await this.ctmsCategoryOptionsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 通关类目分类信息列表(分页) 获取通关类目分类信息列表(分页)
     * 获取通关类目分类信息列表(分页)
     */
    async ctmsCategoryPageListGetRaw(requestParameters: CtmsCategoryPageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataCtmsCategoryRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling ctmsCategoryPageListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling ctmsCategoryPageListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ctms/category/page-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataCtmsCategoryRespVoFromJSON(jsonValue));
    }

    /**
     * 通关类目分类信息列表(分页) 获取通关类目分类信息列表(分页)
     * 获取通关类目分类信息列表(分页)
     */
    async ctmsCategoryPageListGet(requestParameters: CtmsCategoryPageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataCtmsCategoryRespVo> {
        const response = await this.ctmsCategoryPageListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 创建通关类目分类 创建通关类目分类信息
     * 创建通关类目分类信息
     */
    async ctmsCategoryPostRaw(requestParameters: CtmsCategoryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ctms/category`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CtmsCategoryCreateReqVoToJSON(requestParameters['ctmsCategoryCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 创建通关类目分类 创建通关类目分类信息
     * 创建通关类目分类信息
     */
    async ctmsCategoryPost(requestParameters: CtmsCategoryPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.ctmsCategoryPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 批量下载通关类目数据excel 按照列表筛选条件下载数据:/item/page-list,注意:是经过筛选的全部数据 不允许修改/item/page-list 接口内容,你只需要完善此接口即可  输出的excel 内容为:CtmsItemBatchDownloadRespVO 批量下载通关类目数据
     * 批量下载通关类目数据
     */
    async ctmsItemBatchDownloadGetRaw(requestParameters: CtmsItemBatchDownloadGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling ctmsItemBatchDownloadGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling ctmsItemBatchDownloadGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['ctmsCategoryId'] != null) {
            queryParameters['ctmsCategoryId'] = requestParameters['ctmsCategoryId'];
        }

        if (requestParameters['hsCode'] != null) {
            queryParameters['hsCode'] = requestParameters['hsCode'];
        }

        if (requestParameters['itemName'] != null) {
            queryParameters['itemName'] = requestParameters['itemName'];
        }

        if (requestParameters['itemNameEn'] != null) {
            queryParameters['itemNameEn'] = requestParameters['itemNameEn'];
        }

        if (requestParameters['itemNameCn'] != null) {
            queryParameters['itemNameCn'] = requestParameters['itemNameCn'];
        }

        if (requestParameters['list'] != null) {
            queryParameters['list'] = requestParameters['list'];
        }

        if (requestParameters['kcCertification'] != null) {
            queryParameters['kcCertification'] = requestParameters['kcCertification'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderType'] != null) {
            queryParameters['orderType'] = requestParameters['orderType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ctms/item/batch-download`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * 批量下载通关类目数据excel 按照列表筛选条件下载数据:/item/page-list,注意:是经过筛选的全部数据 不允许修改/item/page-list 接口内容,你只需要完善此接口即可  输出的excel 内容为:CtmsItemBatchDownloadRespVO 批量下载通关类目数据
     * 批量下载通关类目数据
     */
    async ctmsItemBatchDownloadGet(requestParameters: CtmsItemBatchDownloadGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.ctmsItemBatchDownloadGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 通关类目批量上传 通关类目批量上传
     * 通关类目批量上传
     */
    async ctmsItemBatchUploadPostRaw(requestParameters: CtmsItemBatchUploadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling ctmsItemBatchUploadPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/ctms/item/batch-upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 通关类目批量上传 通关类目批量上传
     * 通关类目批量上传
     */
    async ctmsItemBatchUploadPost(requestParameters: CtmsItemBatchUploadPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.ctmsItemBatchUploadPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 删除通关类目 删除通关类目信息
     * 删除通关类目信息
     */
    async ctmsItemIdDeleteRaw(requestParameters: CtmsItemIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ctmsItemIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ctms/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 删除通关类目 删除通关类目信息
     * 删除通关类目信息
     */
    async ctmsItemIdDelete(requestParameters: CtmsItemIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.ctmsItemIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 指定编号,获取通关类型信息 获取通关类目信息
     * 获取通关类目信息
     */
    async ctmsItemIdGetRaw(requestParameters: CtmsItemIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCtmsItemRespVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ctmsItemIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ctms/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCtmsItemRespVoFromJSON(jsonValue));
    }

    /**
     * 指定编号,获取通关类型信息 获取通关类目信息
     * 获取通关类目信息
     */
    async ctmsItemIdGet(requestParameters: CtmsItemIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCtmsItemRespVo> {
        const response = await this.ctmsItemIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 修改通关类目 修改通关类目信息
     * 修改通关类目信息
     */
    async ctmsItemIdPutRaw(requestParameters: CtmsItemIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling ctmsItemIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ctms/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CtmsItemUpdateReqVoToJSON(requestParameters['ctmsItemUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 修改通关类目 修改通关类目信息
     * 修改通关类目信息
     */
    async ctmsItemIdPut(requestParameters: CtmsItemIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.ctmsItemIdPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 获取全部通过类型列表(选项列表)(不分页) 获取全部通关类目列表(选项列表)(不分页)
     * 获取全部通关类目列表(选项列表)(不分页)
     */
    async ctmsItemOptionListGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListCtmsItemOptionRespVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ctms/item/option-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListCtmsItemOptionRespVoFromJSON(jsonValue));
    }

    /**
     * 获取全部通过类型列表(选项列表)(不分页) 获取全部通关类目列表(选项列表)(不分页)
     * 获取全部通关类目列表(选项列表)(不分页)
     */
    async ctmsItemOptionListGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListCtmsItemOptionRespVo> {
        const response = await this.ctmsItemOptionListGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * 通关类型列表(分页) 获取通关类目列表(分页)
     * 获取通关类目列表(分页)
     */
    async ctmsItemPageListGetRaw(requestParameters: CtmsItemPageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataCtmsItemRespVo>> {
        if (requestParameters['currentPage'] == null) {
            throw new runtime.RequiredError(
                'currentPage',
                'Required parameter "currentPage" was null or undefined when calling ctmsItemPageListGet().'
            );
        }

        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling ctmsItemPageListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['ctmsCategoryId'] != null) {
            queryParameters['ctmsCategoryId'] = requestParameters['ctmsCategoryId'];
        }

        if (requestParameters['hsCode'] != null) {
            queryParameters['hsCode'] = requestParameters['hsCode'];
        }

        if (requestParameters['itemName'] != null) {
            queryParameters['itemName'] = requestParameters['itemName'];
        }

        if (requestParameters['itemNameEn'] != null) {
            queryParameters['itemNameEn'] = requestParameters['itemNameEn'];
        }

        if (requestParameters['itemNameCn'] != null) {
            queryParameters['itemNameCn'] = requestParameters['itemNameCn'];
        }

        if (requestParameters['list'] != null) {
            queryParameters['list'] = requestParameters['list'];
        }

        if (requestParameters['kcCertification'] != null) {
            queryParameters['kcCertification'] = requestParameters['kcCertification'];
        }

        if (requestParameters['orderBy'] != null) {
            queryParameters['orderBy'] = requestParameters['orderBy'];
        }

        if (requestParameters['orderType'] != null) {
            queryParameters['orderType'] = requestParameters['orderType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ctms/item/page-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataCtmsItemRespVoFromJSON(jsonValue));
    }

    /**
     * 通关类型列表(分页) 获取通关类目列表(分页)
     * 获取通关类目列表(分页)
     */
    async ctmsItemPageListGet(requestParameters: CtmsItemPageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataCtmsItemRespVo> {
        const response = await this.ctmsItemPageListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 创建通关类目 创建通关类目信息
     * 创建通关类目信息
     */
    async ctmsItemPostRaw(requestParameters: CtmsItemPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseLong>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/ctms/item`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CtmsItemCreateReqVoToJSON(requestParameters['ctmsItemCreateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseLongFromJSON(jsonValue));
    }

    /**
     * 创建通关类目 创建通关类目信息
     * 创建通关类目信息
     */
    async ctmsItemPost(requestParameters: CtmsItemPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseLong> {
        const response = await this.ctmsItemPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
